module.exports = __webpack_public_path__ + "static/media/react.11913b6e.svg";